import axios from '../axios'

export const getCodeSearchHistory = ({ fullname, shortname, gender, dob }) =>
    axios.post('/history/view-online', { fullname, shortname, gender, dob })
